"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contests_core_1 = require("@biw/contests-core");
var _a = contests_core_1.translations.selectors, getStringFromBundle = _a.getStringFromBundle, getString = _a.getString;
exports.getStringFromBundle = getStringFromBundle;
exports.default = getString;
//# sourceMappingURL=get-string.js.map